// Formatting + shared option helpers for Life Leverage OS

export const formatPLN = (n) => {
  const num = Number(n || 0);
  return `${num.toLocaleString('pl-PL', { maximumFractionDigits: 0 })} zł`;
};

export const GOAL_CATEGORIES = [
  'Business', 'Finance', 'Health', 'Personal', 'Learning', 'Relationships', 'Spiritual / Mindset',
];

export const GOAL_STATUSES = ['Active', 'In Progress', 'Paused', 'Completed'];

export const PROJECT_CATEGORIES = [
  'Business', 'App Development', 'eBook', 'Sales', 'Finance', 'Personal', 'Learning',
];

export const PROJECT_STATUSES = ['Planning', 'Active', 'Waiting', 'Completed'];

export const TASK_PRIORITIES = ['Low', 'Medium', 'High', 'Critical'];
export const TASK_STATUSES = ['To Do', 'In Progress', 'Done'];

export const HABIT_CATEGORIES = ['Health', 'Work', 'Mindset', 'Learning', 'Finance', 'Relationships'];
export const HABIT_FREQUENCIES = ['Daily', 'Weekdays', 'Weekly'];

export const categoryChip = (cat) => {
  const map = {
    Business: 'bg-white/[0.06] border-white/10 text-foreground/80',
    Finance: 'bg-emerald-400/10 text-emerald-200 border-emerald-300/20',
    Health: 'bg-teal-400/10 text-teal-200 border-teal-300/20',
    Personal: 'bg-sky-400/10 text-sky-200 border-sky-300/20',
    Learning: 'bg-indigo-400/10 text-indigo-200 border-indigo-300/20',
    Relationships: 'bg-rose-400/10 text-rose-200 border-rose-300/20',
    'Spiritual / Mindset': 'bg-amber-400/10 text-amber-200 border-amber-300/20',
    'App Development': 'bg-violet-400/10 text-violet-200 border-violet-300/20',
    eBook: 'bg-cyan-400/10 text-cyan-200 border-cyan-300/20',
    Sales: 'bg-amber-400/10 text-amber-200 border-amber-300/20',
    Work: 'bg-sky-400/10 text-sky-200 border-sky-300/20',
    Mindset: 'bg-amber-400/10 text-amber-200 border-amber-300/20',
  };
  return map[cat] || 'bg-white/[0.06] border-white/10 text-foreground/80';
};

export const statusChip = (status) => {
  const map = {
    Active: 'bg-emerald-400/10 text-emerald-200 border-emerald-300/20',
    'In Progress': 'bg-sky-400/10 text-sky-200 border-sky-300/20',
    Planning: 'bg-indigo-400/10 text-indigo-200 border-indigo-300/20',
    Waiting: 'bg-amber-400/10 text-amber-200 border-amber-300/20',
    Paused: 'bg-white/[0.06] text-foreground/70 border-white/10',
    Completed: 'bg-emerald-400/15 text-emerald-200 border-emerald-300/25',
    'To Do': 'bg-white/[0.06] text-foreground/70 border-white/10',
    Done: 'bg-emerald-400/15 text-emerald-200 border-emerald-300/25',
  };
  return map[status] || 'bg-white/[0.06] border-white/10 text-foreground/80';
};

export const priorityDot = (p) => {
  const map = {
    Low: 'bg-white/40',
    Medium: 'bg-sky-300/80',
    High: 'bg-amber-300/90',
    Critical: 'bg-rose-400',
  };
  return map[p] || 'bg-white/40';
};

export const priorityChip = (p) => {
  const map = {
    Low: 'bg-white/[0.06] text-foreground/70 border-white/10',
    Medium: 'bg-sky-400/10 text-sky-200 border-sky-300/20',
    High: 'bg-amber-400/10 text-amber-200 border-amber-300/20',
    Critical: 'bg-rose-400/10 text-rose-200 border-rose-300/20',
  };
  return map[p] || 'bg-white/[0.06] border-white/10 text-foreground/80';
};

export const financeAmountColor = (type) => {
  if (type === 'income') return 'text-emerald-300';
  if (type === 'expense') return 'text-rose-300';
  return 'text-amber-300';
};

export const financeSign = (type) => {
  if (type === 'income') return '+';
  if (type === 'expense') return '-';
  return '';
};

export const greetingFallback = () => {
  const h = new Date().getHours();
  if (h < 12) return 'Good morning';
  if (h < 18) return 'Good afternoon';
  return 'Good evening';
};

export const formatDate = (iso, lang = 'en') => {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    // Display locale only; stored ISO dates are untouched. Currency formatting stays pl-PL / zł.
    const locale = lang === 'pl' ? 'pl-PL' : lang === 'vi' ? 'vi-VN' : 'en-GB';
    return d.toLocaleDateString(locale, { day: 'numeric', month: 'short' });
  } catch (e) {
    return iso;
  }
};

export const isToday = (iso) => {
  if (!iso) return false;
  const today = new Date().toISOString().slice(0, 10);
  return String(iso).slice(0, 10) === today;
};

export const isPast = (iso) => {
  if (!iso) return false;
  const today = new Date().toISOString().slice(0, 10);
  return String(iso).slice(0, 10) < today;
};
